export default {
  'pages.info.more': 'More Reports',
  'pages.info.page': 'View More',
  'pages.info.content': 'Related content',
};
